<template>
  <div class="customer-orders-list">
    <div class="header-buttons" v-if="showHeaderOps">
      <el-button type="primary" plain size="mini" @click="refreshPage">
        Refresh
      </el-button>
    </div>
    <basic-table :maxHeight="maxHeight" :table-data="groupsPage" :table-headers="tableHeaders"
      :has-actions="showActions" :sortChange="sortChange" :paginationChange="paginationChange"
      :actionWidth="actionWidth" :has-row-expand="true" :showPagination="showPagination" :rowClassName="rowClassName"
      :stripe="!rowClassName" :summary="true">
      <template v-slot:row-expand="props">
        <div class="table-customer-product-detail f-r">
          <div v-for="(product, index) in props.row.products" :key="index" class="product-item">
            <div class="left f-c">
              <div class="stock-info-item first bold-oswald f-r-c">
                <span>{{ product.customerOrderNo }}</span>
                <el-tag v-if="product.serialNoRequired" size="mini" type="danger">(S/N)</el-tag>
              </div>
              <div class="stock-info-item first light-oswald">
                <span>No. {{ product.productNo }}</span>
              </div>
              <div class="stock-info-item barcode">
                <span class="product-name">{{ product.productName }}</span>
              </div>
              <div class="stock-info-item barcode">
                <span>{{ product.barcode }}</span>
              </div>
            </div>
            <div class="right f-c-c-c">
              <div class="f-r">
                <span class="quantity light-oswald">{{ product.cartons }}箱</span>
                <span class="quantity light-oswald">{{ product.quantity }}件</span>
              </div>
              <span class="quantity light-oswald">单箱{{ product.perPackageQty }}件</span>
            </div>
          </div>
        </div>
      </template>
      <template #[totalPackagesSlot]="props">
        <div class="f-r-c-c">
          <span class="bold-oswald packages-count">
          {{ props.row.products.reduce((acc, cur) => acc + cur.quantity, 0) }}
          </span>
        </div>
      </template>
      <template #[customerOrderSlot]="props">
        <span class="bold-oswald pallet-count">
          <div class="table-customer-orders-col f-r">
            <div v-for="(order, index) in props.row.products.map(one => one.customerOrderNo)" :key="index">
              <el-tag>{{ order }}</el-tag>
            </div>
          </div>
        </span>
      </template>
      <template v-slot:row-actions="props">
        <div class="actions f-r">
          <el-button v-if="showLabelAction" size="small" type="text" @click="() => getScanOrderProductLabels(props.row.id)">
            Products
          </el-button>
          <el-button v-if="showLabelAction" size="small" type="text" @click="() => printPalletLabels(props.row.id)">
            Pallets
          </el-button>
          <el-button
            size="small"
            type="text"
            :disabled="true"
            class="warning-text"
            @click="() => openExtraLabelsDialog(props.row)"
          >
            Extra Labels
          </el-button>
        </div>
      </template>
      <template v-slot:footer-ops>
        <el-button type="primary" plain size="mini" @click="refreshPage">
          Refresh
        </el-button>
      </template>
    </basic-table>
    <common-dialog
      ref="extraLabelsDialog"
      title="Extra Labels"
      :inputs-map="morePalletForm"
      :save-cb="morePalletLabels"
      :reset-inputs="resetMoreCount"
    />
  </div>
</template>
<script>
import debounce from 'lodash/debounce'
import cloneDeep from 'lodash/cloneDeep'
import isEqual from 'lodash/isEqual'
// mixin
import { pageJumps } from '@/core/mixin/pages'
// components
import BasicTable from '@/components/common/BasicTable.vue'
// models
// msg
import PagesMessage from '@/core/message/pages'
import { ScanOrderGroupsTableHeaders, MoreLocalPalletsForm } from '@/core/models/order'
// utils
import {
  Ascending,
  Descending,
  DefaultPageSize,
  PageCurrentKey,
  PageSizeKey
} from '@/core/configs/types'
import { labelLocalPalletsGroup, modifyScanOrderGroup, scanOrderGroupProductLabels, searchtScanOrderProducts } from '@/api/order'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { viewPdf } from '@/core/utils'
export default {
  name: 'CustomerOrderList',
  mixins: [pageJumps],
  props: {
    orderId: {
      type: String,
      default: null
    },
    productsQuery: {
      type: Object,
      default: null
    },
    refresh: {
      type: Boolean,
      default: false
    },
    showActions: {
      type: Boolean,
      default: true
    },
    showGroupName: {
      type: Boolean,
      default: true
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    showHeaderOps: {
      type: Boolean,
      default: true
    },
    showLabelAction: {
      type: Boolean,
      default: true
    },
    actionWidth: {
      type: Number,
      default: 140
    },
    maxHeight: {
      type: Number,
      default: -1
    },
    rowClassName: {
      type: Function,
      default: () => { }
    },
    excludeCols: {
      type: Array,
      default: () => []
    }
  },
  components: {
    BasicTable,
    CommonDialog
  },
  data() {
    return {
      customerOrderSlot: 'orders',
      totalPackagesSlot: 'packages',
      productGroups: null,
      loadingData: false,
      pagination: {
        [PageSizeKey]: this.showPagination ? DefaultPageSize : -1,
        [PageCurrentKey]: 1,
        total: 0,
        asc: '',
        desc: ''
      },
      debouncedQuery: debounce(this.fetchProducts, 300),
      morePalletForm: cloneDeep(MoreLocalPalletsForm)
    }
  },
  computed: {
    groupsPage() {
      return {
        records: this.productGroups,
        ...this.pagination
      }
    },
    tableHeaders() {
      const toExclude = [...this.excludeCols]
      if (!this.showGroupName) toExclude.push('groupName')
      return ScanOrderGroupsTableHeaders.filter(one => !toExclude.includes(one.key))
    }
  },
  methods: {
    paginationChange(key, path, value) {
      this.pagination[key] = value
      this.debouncedQuery()
    },
    sortChange(sort) {
      if (sort.order === Ascending) {
        this.pagination.asc = sort.col
        this.pagination.desc = ''
      } else if (sort.order === Descending) {
        this.pagination.desc = sort.col
        this.pagination.asc = ''
      }
      this.debouncedQuery()
    },
    refreshPage() {
      this.debouncedQuery()
    },
    fetchProducts() {
      searchtScanOrderProducts(this.productsQuery).then(res => {
        this.$set(this, 'productGroups', res)
      })
    },
    async fetchCustomerOrders() {
    },
    checkExpand(item) {
      return true
    },
    getScanOrderProductLabels(groupId) {
      scanOrderGroupProductLabels(this.orderId, groupId).then(res => {
        if (res) viewPdf(res)
      })
    },
    printPalletLabels(group) {
      labelLocalPalletsGroup(this.orderId, group, 0, -1).then(res => {
        viewPdf(res)
      })
    },
    openExtraLabelsDialog(group) {
      this.morePalletForm[0].value = group.address
      this.morePalletForm[1].value = group.palletCount
      this.$refs.extraLabelsDialog.open()
    },
    morePalletLabels(inputs) {
      const address = inputs.address
      const original = this.productGroups.find(
        one => one.address.id === address.id
      )
      const count = inputs.moreCount + this.morePalletForm[1].value
      modifyScanOrderGroup(this.orderId, original.id, {
        palletCount: count
      }).then(res => {
        if (res) {
          PagesMessage.emit(PagesMessage.eventMap.REFRESH_ORDER_DETAIL)
          this.$message.success('Successfully!')
          const extraPallets = res.extraPallets
          if (extraPallets && extraPallets.length > 0) {
            labelLocalPalletsGroup(
              this.orderId,
              original.id,
              original.palletCount,
              -1
            ).then(res => {
              viewPdf(res)
            })
            this.$refs.extraLabelsDialog.close()
          }
        } else {
          this.$message.error('More pallets failed!')
        }
      })
      return [false, '']
    },
    resetMoreCount() {
      this.morePalletForm[2].value = this.morePalletForm[2].default
    }
  },
  watch: {
    refresh: {
      handler() {
        this.debouncedQuery()
      },
      immediate: true
    },
    palletQuery: {
      handler(one, two) {
        if (isEqual(one, two)) return
        this.debouncedQuery()
      },
      deep: true
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/styles/common.scss';

.header-buttons {
  margin-bottom: 10px;
}

.table-customer-orders-col {
  gap: 10px;
  flex-wrap: wrap;
}

.table-customer-product-detail {
  gap: 10px;
  flex-wrap: wrap;
  padding: 10px 20px;

  .product-item {
    display: flex;
    gap: 20px;
    padding: 10px;
    background-color: #eee;
    border-radius: 6px;
    .quantity {
      font-size: 24px;
    }
  }
}

.actions {
  flex-wrap: wrap;
}
</style>
